module.exports = __webpack_public_path__ + "img/app_icon_36.1a182100.png";